// extracted by mini-css-extract-plugin
export default {"mobileH1":"MobileTd_mobileH1__Fhwl0","mobileH2":"MobileTd_mobileH2__+4gNh","leader":"MobileTd_leader__cd+DM"};